import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {StorageKeysEnum} from "../../storage/storage-keys.enum";
import {environment} from "../../../../environments/environment";

@Injectable({providedIn: "root"})
export class SyncTokenService {

    private baseEndPoint: string;


    constructor(
        private http: HttpClient,
    ) {
        this.baseEndPoint = environment.apiTokenUrl;
    }

    public synchronizeToken(tokens: any): Observable<any> {
        return this.http.post<any>(`${this.baseEndPoint}/token/sync`, {
            ...tokens,
            publicKey: sessionStorage.getItem(StorageKeysEnum.PUBLIC_KEY),
        });
    }

}
